import styled from 'styled-components';
import { theme } from '../../../../styles/theme';

export const SectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;
export const SectionHeading = styled.h4`
  margin: 0;
  font: inherit;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: ${theme.colors.secondary900};
`;
export const SectionList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;
